<template>
  <div class="index-box">
    <div class="logo-bg">
      <span class="txt">双華株式会社 （SOUKA CORPORATION）</span>
    </div>
    <div class="banner-box">
      <swiperBox
        pagination
        :slidesPerView="1"
        :list.sync="bannerList"
      />
    </div>
    <div class="service">
      <img :src="service" alt="" />
      <div class="info">
        <p class="title">SERVICE</p>
        <p class="sub-title">ものづくりの現場から、<br />
          持続可能な社会を「共創」する</p>
        <p class="word">SOUKA CONRPORATIONは木材、ベニヤ板及び建築用材料の販売
          及び輸出入業務を行っています。</p>
        <p class="word">お客様・パートナーの皆様と共に実現する、持続可能な
          社会を目指しています。</p>
        <p class="btn" @click="handleGo('content')">
          <span class="txt">事業内容の詳細は</span>
          <span class="right">→</span>
        </p>
      </div>
    </div>
    <div class="product">
      <p class="title-box">
        <span class="title">PRODUCT</span>
        <span class="sub-title">取扱商品</span>
      </p>
      <div class="items">
        <div class="left">
          <p
            v-for="(item, index) in productData"
            class="row"
            :class="{active: curProduct === item.key}"
            :key="index"
            @click="handleProductGo(item)"
            @mouseenter="handleProduct(item)"
          >
            <span class="value">{{item.value}}</span>
            <span class="right">→</span>
          </p>
          <p class="btn" @click="handleGo('product')">
            <span class="txt">商品情報の表示</span>
            <span class="right">→</span>
          </p>
        </div>
        <div class="right-box">
          <img
            v-if="curProductHomeImg"
            class="product-img home"
            :src="curProductHomeImg"
            alt=""
          />
          <img
            v-if="curProductImg"
            class="product-img"
            :src="curProductImg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="future">
      <p class="title">FUTURE</p>
      <p class="sub-title">今後の展望</p>
      <introduction />
    </div>
    <div class="product-relative">
      <div class="box">
        <swiperBox1
          navigation
          :slidesPerView="3"
          :list.sync="productRelative"
        />
      </div>
    </div>
  </div>
</template>

<script>
import swiperBox from '../../components/swiperBox'
import swiperBox1 from '../../components/swiperBox1'
import introduction from '../../components/introduction'
import {
  getBanner,
  homeSp
} from '../../api/home'

export default {
  name: 'index',
  components: {
    swiperBox,
    swiperBox1,
    introduction
  },
  data () {
    const {
      home: {
        service,
        // product1,
        product01,
        product02,
        product03,
        product04,
        product05,
        product06,
        product07
      }
    } = this.$images
    return {
      service,
      curProduct: 1,
      productData: [
        // { key: 1, value: '01.家具', url: product1 },
        // { key: 2, value: '02.構造材', url: product1 },
        // { key: 3, value: '03.合板', url: product1 },
        // { key: 4, value: '04.建材', url: product1 },
        // { key: 5, value: '05.LVL間柱', url: product1 },
        // { key: 6, value: '06.集成材', url: product1 },
        // { key: 7, value: '07.木製DIY商品', url: product1 },
        // { key: 8, value: '08.吸音パネ儿', url: product1 },
        // { key: 9, value: '09.原木', url: product1 }
      ],
      productRelative: [
        { id: 1, url: product01 },
        { id: 2, url: product02 },
        { id: 3, url: product03 },
        { id: 4, url: product04 },
        { id: 5, url: product05 },
        { id: 6, url: product06 },
        { id: 7, url: product07 }
      ],
      bannerList: [
        // {
        //   id: 1,
        //   url: banner1
        // }, {
        //   id: 2,
        //   url: banner1
        // }
      ]
    }
  },
  computed: {
    curProductHomeImg () {
      let obj = {}
      this.productData.forEach(v => {
        if (v.key === this.curProduct) obj = v
      })
      return obj.urlHome
    },
    curProductImg () {
      let obj = {}
      this.productData.forEach(v => {
        if (v.key === this.curProduct) obj = v
      })
      return obj.url
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getBannerData()
      this.getProductData()
    },
    async getBannerData () {
      const res = await getBanner({})
      console.log('getBannerData==>', { res })
      const { data } = res
      this.bannerList = data.map(v => {
        return {
          id: v.coverPath,
          url: v.coverPath
        }
      })
    },
    async getProductData () {
      const res = await homeSp()
      console.log('getProductData==>', { res })
      const { data } = res
      this.productData = data.map((v, i) => {
        if (i === 0) this.curProduct = v.id
        return {
          id: v.id,
          name: v.name,
          key: v.id,
          value: `${v.num}.${v.name}`,
          url: (v.sp && v.sp.length > 0 && v.sp[0].coverPath) || '',
          urlHome: (v.sp && v.sp.length > 0 && v.sp[0].homeSpCoverPath) || ''
        }
      })
    },
    handleGo (path) {
      this.$EventBus.$emit('onSelect', `/${path}`)
      this.$router.push({ path: `/${path}` })
    },
    handleProduct (item) {
      const { key } = item
      this.curProduct = key
    },
    handleProductGo (item) {
      const { id } = item
      const path = `/#/product?id=${id}`
      window.location.href = path
      this.$EventBus.$emit('onSelect', path)
      // this.$router.push({ path: `/product?id=${id}` })
    }
  }
}
</script>

<style lang="less" scoped>
.index-box {
  .logo-bg {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 592px;
    height: 1389px;
    background: #374475;

    .txt {
      font-family: 04 KanjyukuGothic;
      font-weight: 400;
      font-size: 20px;
      color: #FFFFFF;
      writing-mode: vertical-lr;
      margin-top: 277px;
      margin-left: 81px;
    }
  }

  .banner-box{
    position: relative;
    z-index: 10;
    margin-left: 178px;
    overflow: hidden;
  }
  .service{
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 115px;
    margin-left: 238px;

    .info{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 160px;

      .title{
        font-family: HarmonyOS_Sans_SC_Bold;
        font-weight: 400;
        font-size: 72px;
        color: #E09B4D;
        line-height: 123px;
        margin-top: 128px;
      }
      .sub-title{
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 48px;
        color: #374475;
        line-height: 68px;
      }
      .word{
        width: 731px;
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
        margin-top: 21px;
      }
    }
  }

  .btn{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 66px;
    background: #FFFFFF;
    border-radius: 37px;
    border: 4px solid #374475;
    padding-left: 40px;
    padding-right: 37px;
    margin-top: 52px;
    cursor: pointer;
    transition: all .2s linear;

    &:hover{
      background-color: #374475;

      .txt{
        color: white;
      }

      .right{
        background: #E6F0F7;
        color: #374475;
      }
    }

    .txt{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 30px;
      color: #374475;
      line-height: 68px;
      transition: all .2s linear;
    }

    .right{
      width: 42px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      background: #E09B4D;
      border-radius: 50%;
      color: white;
      font-size: 20px;
      font-weight: bold;
      margin-left: 12px;
      transition: all .2s linear;
    }
  }

  .product{
    display: flex;
    flex-direction: column;

    .title-box{
      display: flex;
      flex-direction: column;
      margin-left: 172px;
      margin-top: 120px;

      .title{
        font-weight: 400;
        font-size: 72px;
        color: #E09B4D;
        line-height: 123px;
      }
      .sub-title{
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 48px;
        color: #374475;
        line-height: 68px;
      }
    }

    .items{
      width: 100%;
      background: #E6F0F7;

      display: flex;
      flex-direction: row;
      margin-top: 28px;

      .left{
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .row{
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-left: 178px;

          font-family: 04KanjyukuGothic;
          font-weight: 400;
          font-size: 24px;
          color: #333333;
          line-height: 68px;
          cursor: pointer;

          &.active{
            background: #374475;

            .value{
              color: white;
            }
            .right{
              opacity: 1;
            }
          }

          .value{
            width: 770px;
            height: 103px;
            line-height: 103px;
            border-bottom: 1px solid rgba(55,68,117,.3);
            user-select: none;
          }

          .right{
            width: 53px;
            height: 53px;
            line-height: 53px;
            text-align: center;
            border-radius: 50%;
            border: 3px solid #FFFFFF;
            color: white;
            font-size: 24px;
            font-weight: bold;
            position: relative;
            left: -66px;
            opacity: 0;
          }
        }

        .btn{
          margin-left: 178px;
          margin-bottom: 73px;
        }
      }

      .right-box{
        margin-top: -283px;
        width: 834px;
        height: 1278px;
        position: relative;

        .product-img.home{
          width: 791px;
          height: 1140px;
          object-fit: cover;
          position: absolute;
          top: 0px;
          left: 0px;
          z-index: 10;
        }

        .product-img{
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 254px;
          height: 264px;
          object-fit: cover;
          z-index: 11;
          border-radius: 20px;
        }
      }
    }
  }

  .future{
    display: flex;
    flex-direction: column;

    .title{
      font-family: HarmonyOS_Sans_SC_Bold;
      font-weight: 400;
      font-size: 72px;
      color: #E09B4D;
      /*line-height: 123px;*/
      margin-left: 192px;
      margin-top: 60px;
    }
    .sub-title{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 48px;
      color: #374475;
      /*line-height: 68px;*/
      margin-left: 192px;
    }
  }

  .product-relative{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 1663px;
    height: 738px;
    background: #E6F0F7;
    position: relative;
    top: 60px;
    margin-left: 131px;
    z-index: 10;
    position: relative;
    overflow: hidden;

    .box{
      margin: 0px 0px;
      overflow: hidden;
    }

    .angle{
      width: 41px;
      height: 41px;
      line-height: 41px;
      text-align: center;
      margin-left: 20px;
      margin-right: 20px;
      background: #FFFFFF;
      border-radius: 50%;
      border: 3px solid rgba(2, 89, 53, 0.3);
      font-size: 24px;
      font-weight: bold;
      color: rgba(2, 89, 53, 0.3);
      user-select: none;

      &.active{
        border: 3px solid #374475;
        color: #374475;
        cursor: pointer;
      }
    }

    .rows{
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 1453px;
      overflow: hidden;

      .row{
        width: 454px;
        height: 546px;
        margin-right: 45px;
        flex-shrink: 0;
      }

      .img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        user-select: none;
      }
    }
  }
}
</style>
